import React, { useState } from 'react';
import styles from '../../../styles/containers/Lightbox.scss';

import {
  resetObjectStyle,
  selectObjectStyle,
} from '../../../components/CanvasEditor/helpers/fabricHelpers';

import { updateAttachmentVersionAnnotation } from '../../../redux/actions/general/lightbox';
import CanvasEditor from '../../../components/CanvasEditor/CanvasEditor';
import CanvasWrapperHeader from './CanvasWrapperHeader';
import useImageSize from '../hooks/useImageSize';

export const CanvasWrapper = ({ image, annotations, disabled }) => {
  const { imageWithSize, catchError } = useImageSize(image);
  const [viewer, setViewer] = useState(null);
  const [fabricOverlay, setFabricOverlay] = useState(null);

  const handleSubmit = (fabricOverlay, refreshData = false) => {
    const canvas = fabricOverlay.fabricCanvas();
    const activeObject = canvas.getActiveObject();

    if (activeObject?.type === 'activeSelection') {
      activeObject.getObjects().forEach((child) => {
        child.setCoords();
      });
      canvas.discardActiveObject();
    }

    activeObject && resetObjectStyle(activeObject);

    const allObjects = canvas
      .getObjects()
      .filter(
        (obj) => !['controlpoint', 'arrow-head'].includes(obj.objectType),
      );

    const serializedObjects = {
      objects: allObjects.map((obj) =>
        obj.toObject([
          'objectType',
          'originalLeft',
          'originalTop',
          'userID',
          'lockMovementX',
          'lockMovementY',
          'userFullName',
          'objectCaching',
        ]),
      ),
    };

    activeObject && selectObjectStyle(activeObject);

    if (image?.attachment_version_id) {
      updateAttachmentVersionAnnotation(
        image.attachment_version_id,
        JSON.stringify(serializedObjects)
      );
    }
  };

  if (catchError)
    return (
      <div className={styles.error}>
        <span>Corrupted image.</span>
      </div>
    );

  return (
    <>
      <CanvasWrapperHeader
        image={image}
        imageWithSize={imageWithSize}
        viewer={viewer}
        fabricOverlay={fabricOverlay}
        disabled={disabled}
      />

      <div className={styles.canvasWrapper}>
        {!imageWithSize && (
          <div className={styles.loader}>
            <div className={styles.spinner} />
            <span>Loading image…</span>
          </div>
        )}

        {image && imageWithSize && (
          <CanvasEditor
            onSubmit={handleSubmit}
            disabled={disabled}
            onViewerReady={setViewer}
            onFabricOverlayReady={setFabricOverlay}
            source={imageWithSize}
            sourceType='image'
            annotations={annotations}
          />
        )}
      </div>
    </>
  );
};
